export default __webpack_public_path__ + "static/media/logo-trials@2x.1450121c.svg";